module.exports = __webpack_public_path__ + "img/组 5.a847dad9.png";